const toast = {
    createTestTaker: 'createTestTaker',
    createAffiliation: "createAffiliation",
    createAssessment: "createAssessment"
}

export default toast